import React from "react";
import PropTypes from "prop-types";
import { IoIosHourglass } from "react-icons/io";
import { FaMapMarkerAlt } from "react-icons/fa";

import "./Coupon.scss";

const hideOverflowStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};

class Coupon extends React.Component {
  state = {};

  render() {
    const { name, locations, expires, hideOverflow, id, onClick } = this.props;
    const locationString = locations.join(", ");

    return (
      <div className="couponDiv" id={id} onClick={onClick}>
        <div className="couponHeader">
          <img src="https://placehold.it/200" alt="company logo" />
          <div className="couponInfo">
            <h2>Free</h2>
            <span>{name}</span>
          </div>
        </div>
        <div className="couponBody">
          <div className="couponBodyLeft">
            <span style={hideOverflow && hideOverflowStyle}>
              <IoIosHourglass /> Expires on {expires}
            </span>
            <span style={hideOverflow && hideOverflowStyle}>
              <FaMapMarkerAlt /> Available at {locationString}
            </span>
          </div>
          <img
            className="shareWithFriend"
            src={require("../../assets/coupons/refer.png")}
            alt="send sample to friend"
            onClick={() => alert("Sending...")}
          />
        </div>
      </div>
    );
  }
}

Coupon.propTypes = {
  name: PropTypes.string,
  locations: PropTypes.array,
  expires: PropTypes.string,
  hideOverflow: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func
};

export default Coupon;
